<template>
  <BaseDrawer
    :is-open="isOpen"
    shrink
    @close="emit('close')"
  >
    <template #title>Enter Merchant ID</template>
    <form
      class="my-6 flex flex-col space-y-6 px-4"
      @submit="onSubmit"
    >
      <div
        class="text-center text-sm text-background-fg/50"
      >
        Enter a new merchant ID
      </div>
      <TextInputFormField name="mid" />
      <ActionButtonPrimary
        type="submit"
        :disabled="submitDisabled"
        class="self-center"
        :is-loading="isSubmitting"
        >Confirm</ActionButtonPrimary
      >
    </form>
  </BaseDrawer>
</template>

<script setup lang="ts">
import { queryClient } from "@/queryClient"
import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import { requiredTrimmedString } from "@/forms/validation/stringFieldSchemas"

defineProps<{ isOpen: boolean }>()

const emit = defineEmits<{
  (eventName: "close"): void
}>()

const { setOverrideMid } = useOverrideMid()
const { clearTokens } = useAuth()
const { clearCurrentOrder } = useCurrentOrder()

const formSchema = z.object({
  mid: requiredTrimmedString("Merchant ID is required"),
})

const { handleSubmit, meta, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  keepValuesOnUnmount: true,
  initialValues: {
    mid: "",
  },
})

const submitDisabled = computed(() => !meta.value.valid)

const onSubmit = handleSubmit(async (formValues) => {
  await setOverrideMid(formValues.mid)
  clearCurrentOrder()
  queryClient.invalidateQueries()
  clearTokens()
})
</script>
